import React, { useState, useEffect } from "react";
import SelectPicker from "rsuite/esm/SelectPicker";
import DatePicker from "rsuite/esm/DatePicker";
import Modal from "rsuite/esm/Modal";
import Button from "rsuite/esm/Button";
import moment from "moment";
import toast from "react-hot-toast";
import { getCookie } from "../../../common/Utility";
import useFetchPost from "../../hooks/useFetchPost";


const statusData = ["Credit Card", "Wire Transfer"].map((item) => ({
  label: item,
  value: item,
}));

const MarkAsPaidNew = ({ data, setActionColData, refetchAgGrid}) => {
  const [open, setOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [description, setDescription] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [errors, setErrors] = useState({});

  const { fetchPostData } = useFetchPost();
  let user_uuid = getCookie("muvi_useruuid");

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setOpen(true);
    }
  }, [data]);

  const handleClose = () => {
    setOpen(false);
    setActionColData((prevState) => ({
      ...prevState,
      openModal: "",
      markAsPaidModalData: {}
    }));
    setPaymentMode("");
    setDescription("");
    setPaymentDate(null);
    setErrors({});
  };

  const handleChangeDate = (value) => {
    if (!value) {
      setPaymentDate(null);
    } else {
      setPaymentDate(value);
    }
  };

  const handleSubmit = async () => {
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      const postData = {
        product_key: data && data.product_key,
        user_uuid: data && data.customer_user_uuid,
        milestone_uuid: data && data.milestone_uuid,
        milestone_payment_mode: paymentMode,
        milestone_receive: paymentDate
          ? moment(paymentDate).format("YYYY-MM-DD")
          : "",
        milestone_payment_note: description,
        muvi_useruuid: user_uuid,
        mautic_id: data && data.mautic_id,
      };

      let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/mark-as-paid";
      let responseData;
      try {
        responseData = await fetchPostData(crmStagingUrl, postData);
      } catch (error) {
        console.error("Error:", error);
      }
      if (responseData && responseData.code === 200) {
        // setApiRun(true);
        refetchAgGrid();
        toast.success(responseData.message || "Marked as paid successfully")
        handleClose();
      } else {
        const errorMessage =
          responseData && responseData.message
            ? responseData.message
            : "An error occurred";
        toast.error(errorMessage);
        // Don't close modal on error, let user retry
      }
    } else {
      setErrors(errors);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!paymentMode.trim()) {
      errors.paymentMode = "Mode of Payment is required";
    }
    if (!paymentDate) {
      errors.paymentDate = "Date of Payment is required";
    }
    if (!description.trim()) {
      errors.description = "Notes is required";
    }
    return errors;
  };

  return (
    <Modal open={open} onClose={handleClose} size="sm">
      <Modal.Header>
        <Modal.Title>Mark as Paid</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label className="control-label">Mode of Payment</label>

            <SelectPicker
              data={statusData}
              name="milestone_payment_mode"
              value={paymentMode}
              onChange={setPaymentMode}
              style={{ width: "100%", zIndex: 1050 }}
              block
              searchable={false}
              placeholder="Select Mode of Payment"
            />
            {errors.paymentMode && (
              <span className="text-danger">{errors.paymentMode}</span>
            )}
          </div>
          <div className="form-group">
            <label className="control-label">Date of Payment</label>
            <DatePicker
              oneTap
              name="milestone_receive"
              block
              value={paymentDate}
              onChange={handleChangeDate}
            />
            {errors.paymentDate && (
              <span className="text-danger">{errors.paymentDate}</span>
            )}
          </div>

          <div className="form-group">
            <label className="control-label">Notes</label>

            <textarea
              className="form-control"
              rows="3"
              autoComplete="off"
              placeholder="Enter Note"
              name="milestone_payment_note"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
            {errors.description && (
              <span className="text-danger">{errors.description}</span>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} appearance="default">
          Close
        </Button>
        <Button onClick={handleSubmit} appearance="primary">
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MarkAsPaidNew;


// WEBPACK FOOTER //
// ./src/components/crm/deals/components/MarkAsPaid.js